export function isTimeMachineReport (report) {
  return Boolean(report && report.event === 'timeMachine')
}

export function getMineReportDisplayMeta (report) {
  return isTimeMachineReport(report)
    ? { tag: 'TimeMachine', category: 'Time Machine' }
    : { tag: 'Reporting', category: 'Reporting Heatmaps' }
}
